import React from 'react';
import Sales from './Sales';

function AddSale() {
  return <Sales initialViewMode="add" />;
}

export default AddSale;



